import { mountComponents } from 'react-sinatra-ujs';
import OrderTable from "./components/OrderTable.jsx";
import LabMaintenanceForm from "./components/LabMaintenanceForm.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import './orderentry';

mountComponents({
    OrderTable: OrderTable,
    LabMaintenanceForm: LabMaintenanceForm,
    Dashboard: Dashboard
});
